import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { BraintreeService } from '@app/shared/services/braintree/braintree.service';
import { LazyloadjsService } from '@app/shared/services/lazyloadjs/lazyloadjs.service';
import { AddressService } from '@app/shared/services/address/address.service';
import { IsubmitProfileInfo } from './IsubmitProfileInfo';
import { IprofileInfo } from './IprofileInfo';
import { LoaderService } from '../../../../core/services/loader/loader.service';


interface ResponseApi {
  StatusCode: number;
  Message: string;
}

@Component({
  selector: 'app-welcome-screen',
  templateUrl: './welcome-screen.component.html',
  styleUrls: ['./welcome-screen.component.css']
})
export class WelcomeScreenComponent implements OnInit {

  @ViewChild('emailInput') emailInput: ElementRef;
  private configBrainTree: { env: string; token: string; };
  disabledForm = true;
  UserId: any;
  emailPaypal: string;
  namePaypal: string;
  //filePdf = '';
  constructor(public dialogRef: MatDialogRef<WelcomeScreenComponent>,
    private notificationService: NotificationService,
    private loader: LoaderService,
    private brainTreeService: BraintreeService,
    private readonly svc: LazyloadjsService,
    private addressService: AddressService) {

    this.UserId = localStorage.getItem('userId');
  }

  public listPanels: any = {
    merchLoop: true,
    final: false
  };

  ValidInput() {
      this.disabledForm = !this.emailInput.nativeElement.checkValidity();
  }
  LoadPaypalAndBrainTreeLib() {
    this.svc.lazyLoadPaypalAndBrainTree().subscribe(useless => {
      this.initConfigPaypalAndBrainTree();
    });
  }

  initConfig() {

    this.addressService.getStoreAdminById(this.UserId).subscribe((res: any) => {
      this.configBrainTree = {
        env: res.Data.ResponseData.brainTreeConfig.env,
        token: res.Data.ResponseData.brainTreeConfig.clientToken
      };

      //For shopify auto sync we have already code in the shopify thus we are not usng this here
      //this.LoadPaypalAndBrainTreeLib();
    });
  }

  submitProfileInfo(data: IsubmitProfileInfo) {
    this.addressService.updateStoreAdminProfile(data).subscribe((res: any) => {
    });
  }

  getProfileInfo(): Promise<IprofileInfo> {
    return new Promise((resolve) => {
      this.addressService.getStoreAdminById(this.UserId).subscribe((res: any) => {
        resolve(res);
      });
    });
  }

  initConfigPaypalAndBrainTree() {
    const config = this.configBrainTree;
    const brainTree = this.brainTreeService;
    const UserId = this.UserId;
    const notif = this.notificationService;
    // @ts-ignore
    window.braintree.client.create({
      authorization: config.token
    }, (clientErr: any, clientInstance: any) => {

      // Stop if there was a problem creating the client.
      // This could happen if there is a network error or if the authorization
      // is invalid.
      if (clientErr) {
        console.error('Error creating client:', clientErr);
        return;
      }

      // Create a PayPal Checkout component.
      // @ts-ignore
      window.braintree.paypalCheckout.create({
        client: clientInstance
      }, (paypalCheckoutErr: any, paypalCheckoutInstance: any) => {

        // Stop if there was a problem creating PayPal Checkout.
        // This could happen if there was a network error or if it's incorrectly
        // configured.
        if (paypalCheckoutErr) {
          console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
          return;
        }

        // Set up PayPal with the checkout.js library
        // @ts-ignore
        window.paypal.Button.render({
          env: config.env, // or 'sandbox'
          style: {
            size: 'large',
            color: 'blue',
            shape: 'rect',
            label: 'pay',
            tagline: 'false'
          },
          payment: function () {
            return paypalCheckoutInstance.createPayment({
              flow: 'vault',
              billingAgreementDescription: 'Authorize automatic payments for shopify order',
              enableShippingAddress: false
            });
          },

          onAuthorize: (data: any, actions: any) => {
            return paypalCheckoutInstance.tokenizePayment(data, (err: any, payload: any) => {
              // Submit `payload.nonce` to your server.
         
              // @ts-ignore
              brainTree.submitNonce({
                nonce: payload.nonce,
                userid: UserId
              }).subscribe((res: any) => {
                // tslint:disable-next-line:no-shadowed-variable
                const data: ResponseApi = res;
                if (data.StatusCode === 200) {
                  notif.success('Successfully connected with paypal', 'Connected');
                } else {
                  notif.error(data.Message, 'Error');
                }
              });
            });
          },

          onCancel: (data: any) => {
            this.nextPanel('final');
            console.log('checkout.js payment cancelled');
          },

          onError: function (err: any) {
            console.error('checkout.js error', err);
          }
        }, '#paypal-button').then(function () {
          // The PayPal button will be rendered in an html element with the id
          // `paypal-button`. This function will be called when the PayPal button
          // is set up and ready to be used.
        });

      });

    });
  }



  async submitFormMerchLoop() {
    this.loader.show();
    const result = await this.getProfileInfo();
    const dataProfile = result.Data.ResponseData;
    const data: IsubmitProfileInfo = {
      FirstName: dataProfile.FirstName,
      LastName: dataProfile.LastName,
      PhoneNumber: dataProfile.PhoneNumber,
      Email: dataProfile.Email,
      AddressLine: dataProfile.AddressInfo.AddressLine,
      Zipcode: dataProfile.AddressInfo.ZipCode,
      StateId: dataProfile.AddressInfo.StateId.toString(),
      CountryId: dataProfile.AddressInfo.CountryId.toString(),
      City: dataProfile.AddressInfo.City,
      LandMark: dataProfile.AddressInfo.LandMark,
      UserName: dataProfile.Email,
      ProfileImage: null,
      Facebook_pixel: dataProfile.Facebook_pixel,
      AccountHolderName: dataProfile.StoreOwnerAccInfoModel != null ? dataProfile.StoreOwnerAccInfoModel.Account_HolderName : null,
      AccountNumber: dataProfile.StoreOwnerAccInfoModel != null ? dataProfile.StoreOwnerAccInfoModel.Account_Number : null,
      BankName: dataProfile.StoreOwnerAccInfoModel != null ? dataProfile.StoreOwnerAccInfoModel.Bank_Name : null,
      Google_code: dataProfile.Google_code,
      //SSN_No: null,
      //EIN_No: null,
      BankLocation: dataProfile.StoreOwnerAccInfoModel != null ? dataProfile.StoreOwnerAccInfoModel.Bank_Location : null,
      PayPal_AccHolderName: this.namePaypal,
      PayPal_EmailAddress: this.emailPaypal,
      UserId: this.UserId,
      ModifiedBy: this.UserId,
      CurrentPassword: '',
      Password: '',
      ConfirmPassword: '',
      //pdfw9: this.filePdf,
      brain_tree_userid: '',
    };
    this.submitProfileInfo(data);
    this.nextPanel('final');
    this.loader.hide();
  }

  ngOnInit() {
    this.initConfig();
  }

  nextPanel(showPanel: string) {
    // tslint:disable-next-line:forin
    for (const panel in this.listPanels) {
      if (this.listPanels.hasOwnProperty(panel)) {
        this.listPanels[panel] = false;
      }
    }
    this.listPanels[showPanel] = true;
  }

}
